import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../../Components/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { FaAngleLeft, FaBackward, FaEye, FaEyeSlash } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import logo from "../../../src/Images/logo_only.png";
import ButtonDropDown from "../../Components/buttonDropDown";
import { packetStatusThunk } from "../../Redux/thunks/packetStatusThunk";
import { RESET_ALL_STATES } from "../../Redux/actions/actions";
import Navigation from "../../Components/Nav/Navigation";
import NavBar from "../../Components/Nav/newNavBar";
import background from "../../assets/background/background.jpg";
import NotificationModal from "../../Components/NotificationModal";
import StatusModal from "../../Components/statusModal";
import { Loader } from "lucide-react";

const Status = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoading, error, data } = useSelector(
        (state) => state.packetStatus
    );

    const { t } = useTranslation();
    const [regID, setRegID] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [showError, setShowError] = useState(false);
    const [triggerSubmit, setTriggerSubmit] = useState(false);
    const [statusModal, setOpenStatusModal] = useState(false);
    const [openNotificationModal, setOpenNotificationModal] = useState(false);

    useEffect(() => {
        if (error) {
            setOpenNotificationModal(true);
        }
        if (data) {
            setOpenStatusModal(true);
        }
    }, [error, data]);

    useEffect(() => {
        setOpenNotificationModal(false);
        setOpenStatusModal(false);
    }, []);
    const handleButtonClick = (event) => {
        event.preventDefault();
        // dispatch({ type: RESET_ALL_STATES });
        setShowError("");
        setTriggerSubmit(true);
    };

    const handleSubmit = async () => {
        dispatch(packetStatusThunk(regID));
        setShowError(error);
        setSubmitDisabled(false);
    };

    useEffect(() => {
        if (triggerSubmit) {
            handleSubmit();
            setTriggerSubmit(false);
        }
    }, [triggerSubmit]);

    const handleRegIdChange = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        if (value.length <= 29) {
            setRegID(value);
        }
    };

    return (
        <div className='relative flex flex-col min-h-[100dvh] md:min-h-[100dvh] overflow-hidden bg-cover bg-fin-verification'>
            <NavBar />
            <div className='relative flex flex-col overflow-y-scroll scrollbar-hide py-32 md:min-h-screen md:pb-[6%] items-center justify-center bg-cover bg-opacity-6 font-barlow px-5'>
                <form
                    onSubmit={handleButtonClick}
                    className='w-full max-w-[500px] md:min-w-[600px] text-center shadow-lg rounded-2xl overflow-hidden'
                >
                    <div className='bg-[#184C61] p-3 text-white flex items-center justify-between'>
                        <Link to='/'>
                            <FaAngleLeft size={24} />
                        </Link>
                        <h2 className='text-base md:text-2xl font-semibold'>
                            {t("track-status")}
                        </h2>
                        <div></div>
                    </div>
                    <div className='p-6 flex flex-col gap-2 text-MetallicBlue bg-faydagrey'>
                        <h2 className='text-sm md:text-xl'>{t("enter-rid-fin-fan")}</h2>

                        <div className='flex items-center w-full pb-2 md:pb-0 b-yellow-300'>
                            <div className='flex justify-center w-full'>
                                <input
                                    type='number'
                                    name='rid'
                                    id='rid'
                                    value={regID}
                                    onChange={(e) => handleRegIdChange(e)}
                                    placeholder={t("rid-fan-fin-placeholder")}
                                    minLength={12}
                                    maxLength={29}
                                    autoComplete='off'
                                    inputMode='numeric'
                                    className='block w-full px-4 py-2 text-sm md:text-lg text-center placeholder-gray-400 border border-gray-300 rounded-md shadow-sm focus:ring-nidblue focus:border-nidblue'
                                />
                            </div>
                        </div>

                        <div className='flex items-center justify-center md:pt-3 b-gray-600'>
                            <button
                                type='submit'
                                disabled={isLoading || submitDisabled}
                                className={`
                          ${
                              isLoading
                                  ? "disabled hover:bg-gray-300 hover:text-gray-500 hover:cursor-not-allowed"
                                  : ""
                          }
                          w-[35%] md:w-[32%] bg-nidblue text-white font-bold py-2 px-4  rounded-lg hover:scale-95  hover:bg-nidyellow focus:outline-none focus:ring focus:nidgreen focus:ring-opacity-50 transition duration-300 ease-in-out`}
                            >
                                {isLoading ? (
                                    <div className='flex items-center gap-2 justify-center'>
                                        <Loader className='animate-spin' />
                                        {t("home-button-verifying")}
                                    </div>
                                ) : (
                                    t("home-button-proceed")
                                )}
                            </button>
                            {isLoading && <Spinner />}
                        </div>
                        {error && (
                            <p className='mt-2 text-base md:text-base text-center text-red-500'>
                                {error ? error?.message : ""}
                            </p>
                        )}
                    </div>
                </form>
            </div>

            <NotificationModal
                open={openNotificationModal}
                error={error}
                handleClose={() => setOpenNotificationModal(false)}
            />

            {!isLoading ? (
                <NotificationModal
                    open={openNotificationModal}
                    error={true}
                    title='Error'
                    message={error}
                    handleClose={() => setOpenNotificationModal(false)}
                />
            ) : null}
            <StatusModal
                open={statusModal}
                message={data}
                handleClose={() => setOpenStatusModal(false)}
            />
        </div>
    );
};

export default Status;
